import ImageUploader from './image-uploader';

export default ImageUploader;
